import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

export default function Cards({ data, headerAlign, descriptionAlign, buttonAlign, imageHeight, sizes, bgColor }) {

    const [maxTitleHeight, setMaxTitleHeight] = React.useState(0);
    const [maxDescriptionHeight, setMaxDescriptionHeight] = React.useState(0);
    const titleRefs = React.useRef([]);
    const descriptionRefs = React.useRef([]);

 React.useEffect(() => {
        const titleHeights = titleRefs.current.map(ref => ref ? ref.offsetHeight : 0);
        const descriptionHeights = descriptionRefs.current.map(ref => ref ? ref.offsetHeight : 0);
        
        setMaxTitleHeight(Math.max(...titleHeights));
        setMaxDescriptionHeight(Math.max(...descriptionHeights));
    }, [data]);

    return (
        <Grid container spacing={4} paddingBottom={'1px'}>
            {data.map((item, index) => (
                <Grid key={index} size={sizes ?? { xs: 12, sm: 6, md: 4, lg: 4 }}>
                    <Grid container gap={'33px'}>
                        <Grid size={12}  bgcolor={bgColor ?? 'unset'}>
                            {
                                item.imageUrl ?
                                    <Box component={'img'} src={item.imageUrl} width={1} height={imageHeight ?? 1} sx={{ objectFit: 'cover' }} />
                                    :
                                    <Box height={'300px'} bgcolor={'#DBDAD9'} width={'100%'}>
                                    </Box>
                            }
                        </Grid>
                        <Grid size={12}>
                            <Grid container>
                                <Grid size={12}>
                                    <Typography variant="h3" fontSize={'24px'} fontWeight={'bold'} textAlign={headerAlign ?? 'unset'} color='text.secondary' ref={(el) => titleRefs.current[index] = el} sx={{ minHeight: `${maxTitleHeight}px` }}>{item.header}</Typography>
                                    {
                                        item?.description &&
                                        <Typography ref={(el) => descriptionRefs.current[index] = el} sx={{ minHeight: `${maxDescriptionHeight}px` }} variant="body1" marginTop={'7px'} fontSize={'1rem'} textAlign={descriptionAlign ?? 'unset'} color='text.secondary'>{item.description}</Typography>
                                    }
                                </Grid>
                                {
                                    item.buttonText &&
                                    <Grid size={8} marginX={buttonAlign ?? 'unset'} marginTop={'20px'}>
                                        <Button LinkComponent={Link} to={item?.url} variant='outlined' fullWidth className='borderRadiusFlat borderWidth2 buttonPaddingY10' sx={{ borderColor: 'text.secondary', color: 'text.secondary', fontSize: '17px', maxHeight: '50px', maxWidth: '246px' }}>{item.buttonText}</Button>
                                    </Grid>
                                }
                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>
            ))}
        </Grid>
    )
}